import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import uiconfig from "CommonState/uiconfig";
import {
  Alert,
} from "react-bootstrap";
import apifetch from "CommonCore/apifetch";
import {
  Panel,
} from "CommonComponents/bricks";
import {
  ANTRAGSTATUS,
  ROLLEN,
} from "App/constants";
import {
  formatDateTime,
} from "CommonCore/l10n";
import TR from "Common/translate";

@uiconfig
@store("user", "k_antragstatusLookup")
export default class AntragHistorieWidget extends Component {
  constructor() {
    super();
    this.state = {};
  }

  load = async function(antrag) {
    // Dokumente zum Antrag laden
    const liste = await apifetch(`/api/shkantrag/antrag/statushist/${ antrag.a_id }`);
    this.setState({ liste: liste.data });
  };

  componentDidMount = () => {
    this.load(this.props.antrag);
  };

  render() {
    const { liste } = this.state;
    const { k_antragstatusLookup } = this.props;

    return <div className='detail-form'><Panel>
      <table width='100%'>
        <thead>
          <tr><th className='text-center'><h3>Verwaltung</h3></th><th /><th className='text-center'><h3>{TR("Antragsteller")}</h3></th></tr>
        </thead>
        <tbody>
          {_.map(liste, (l, i) => {
            const status_start = k_antragstatusLookup && k_antragstatusLookup[l.asf_aasid];

            const istAst = status_start && (status_start.as_id == ANTRAGSTATUS.STATUS_NEU || (status_start.as_roid == ROLLEN.ROLLE_ANTRAGSTELLER));

            const content = <Alert variant='info'>{formatDateTime(l.ash_zeit)} - {l.ash_nutzer}
              <br /><b> {l.ash_statuswechsel}</b>
            </Alert>;
            return <tr key={i}><td width='45%'>{!istAst ? content : ""} </td>
              <td width='10%' className='text-center' />
              <td width='45%'> {istAst ? content : ""}</td>
            </tr>;
          })}
        </tbody>
      </table>
    </Panel></div>;
  }
}
